import { render } from "./CompanyKpi.vue?vue&type=template&id=1c3402d4&scoped=true"
import script from "./CompanyKpi.vue?vue&type=script&lang=js"
export * from "./CompanyKpi.vue?vue&type=script&lang=js"

import "./CompanyKpi.vue?vue&type=style&index=0&id=1c3402d4&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3402d4"]])

export default __exports__